var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login-",
    transform: "translate(-1.989 -1.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M21.574,1.989H6.4A4.42,4.42,0,0,0,1.989,6.4V8.091a1.2,1.2,0,1,0,2.4,0V6.4A2.02,2.02,0,0,1,6.4,4.387h15.17A2.02,2.02,0,0,1,23.592,6.4v15.17a2.02,2.02,0,0,1-2.018,2.018H6.4a2.02,2.02,0,0,1-2.018-2.018V19.9a1.2,1.2,0,1,0-2.4,0v1.673A4.42,4.42,0,0,0,6.4,25.989h15.17a4.42,4.42,0,0,0,4.415-4.415V6.4a4.42,4.42,0,0,0-4.415-4.415Z",
    transform: "translate(0 0)",
    fill: "#efc04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M2.042,12a1,1,0,0,0,1,1h8.547L10.3,14.3A1,1,0,1,0,11.71,15.71l3-3a1,1,0,0,0,0-1.415l-3-3A1,1,0,0,0,10.3,9.71L11.589,11H3.042a1,1,0,0,0-1,1Z",
    transform: "translate(0 1.99)",
    fill: "#efc04b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginActive);
export default __webpack_public_path__ + "static/media/login-active.d8ecc3263a0e48ab7ed5faaf5b9a8b4c.svg";
export { ForwardRef as ReactComponent };